import { Intent } from 'enums';
import { useContext as useEventTrackerContext } from 'providers/EventTracker';
import { EventActionConfigKey } from 'providers/EventTracker/initialContext';
import React, { useCallback } from 'react';
import { LinkProps } from 'react-router-dom';

import { BaseLink } from './styles';

export interface IProps {
  /**
   * Flag indicating that the active state should be used be default (e.g. hover state)
   * @default false
   */
  active?: boolean;
  /**
   * Children
   */
  children?: any;
  /**
   * The intent applied to the link
   * @default Intent.NONE
   */
  intent?: Intent | null;
  /**
   * A key that used to get an event tracker config - see {@link providers/EventTracker/initialContext}
   * This config sets whether a click event is logged in google analytics
   */
  eventTrackerConfigKey?: EventActionConfigKey;
  style?: React.CSSProperties;
}

const Link = ({
  active,
  color,
  to,
  intent = Intent.NONE,
  className,
  children,
  eventTrackerConfigKey,
  style,
  onClick,
  ...rest
}: IProps & LinkProps) => {
  const { onClickTrackEvent } = useEventTrackerContext();

  const onClickWrapped = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      onClickTrackEvent({ eventTrackerConfigKey });

      if (onClick) {
        onClick(event);
      }
    },
    [onClickTrackEvent, onClick, eventTrackerConfigKey],
  );

  return (
    <BaseLink
      $color={color}
      to={to}
      $intent={intent}
      $active={active}
      className={className}
      style={style}
      onClick={onClickWrapped}
      {...rest}
    >
      {children}
    </BaseLink>
  );
};

export default Link;
